/**
 * Articolo — Gallery flexible content (lightbox).
 *
 * PhotoSwipe sulle griglie [data-flex-gallery] del layout "slider" in modalità
 * "Griglia foto" (template-parts/flex-content/slider.php). Un'unica istanza col
 * selettore stringa gestisce anche più griglie nello stesso articolo.
 * Didascalia in overlay letta da data-pswp-caption (stesso pattern della
 * gallery dei settori, src/js/settore-gallery.js).
 */
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

( function () {
	'use strict';

	if ( ! document.querySelector( '[data-flex-gallery]' ) ) {
		return;
	}

	const lightbox = new PhotoSwipeLightbox( {
		gallery: '[data-flex-gallery]',
		children: 'a',
		pswpModule: PhotoSwipe,
		bgOpacity: 0.96,
		wheelToZoom: true,
	} );

	// Didascalia in overlay (dal data-pswp-caption dell'anchor attivo).
	lightbox.on( 'uiRegister', () => {
		lightbox.pswp.ui.registerElement( {
			name: 'flex-caption',
			order: 9,
			isButton: false,
			appendTo: 'root',
			onInit: ( el, pswp ) => {
				el.className = 'flex-pswp__caption';
				pswp.on( 'change', () => {
					const anchor = pswp.currSlide && pswp.currSlide.data.element;
					el.textContent = anchor ? ( anchor.getAttribute( 'data-pswp-caption' ) || '' ) : '';
				} );
			},
		} );
	} );

	lightbox.init();
}() );
